import { type RouteLocationNormalized } from 'vue-router';
import { storeToRefs } from 'pinia';
import { IUserRole } from '@/types/profile/IUserRole';
import useProfileStore from '@/stores/profile';

export function roleAccessMiddleware(to: RouteLocationNormalized, from: RouteLocationNormalized) {
    const profileStore = useProfileStore();
    const { userInfo } = storeToRefs(profileStore);
    if (userInfo.value) {
        if (userInfo.value.role === IUserRole.STUDIO_MASTER) {
            console.log('userInfo.value', userInfo.value);
            return false;
        }
    }
}

export default roleAccessMiddleware;
